import { dbStore, TableId } from "./DbStore";

export async function urlToTable(url: string): Promise<TableId | undefined> {
  const result = await dbStore.cachedTables.get(url);
  return result?.tableId;
}
